import * as React from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import { hourGutter } from '../../dateFormat'
import { HOUR_PX, HOURS, START_HOUR } from './weekGeometry'

/**
 * The shared hour-label gutter used by both the week body and the day column, so
 * the label format, gridline alignment, and colours stay identical between views.
 */
export function HourGutter() {
  const theme = useTheme()

  return (
    <Box sx={{ backgroundColor: theme.palette.grey[50] }}>
      {HOURS.map((hour) => (
        // Label is nudged onto its gridline via `top`, not a negative margin:
        // margins accumulate down the stack, shrinking every row by 6px.
        <Box
          key={hour}
          sx={{
            height: `${HOUR_PX}px`,
            textAlign: 'right',
            pr: '8px',
            position: 'relative',
            top: '-6px',
            fontFamily: theme.typography.fontFamily,
            fontSize: '11px',
            fontWeight: 500,
            color: theme.palette.text.secondary,
          }}
        >
          {/* No midnight label: it would sit half under the sticky header. */}
          {hour === START_HOUR ? null : hourGutter(hour)}
        </Box>
      ))}
    </Box>
  )
}
